// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SetUnifiedGroupLastVisitedTimeRequest from "../contract/SetUnifiedGroupLastVisitedTimeRequest";

export default function setUnifiedGroupLastVisitedTimeRequest(data: SetUnifiedGroupLastVisitedTimeRequest): SetUnifiedGroupLastVisitedTimeRequest {
    const result: SetUnifiedGroupLastVisitedTimeRequest = {
        __type: "SetUnifiedGroupLastVisitedTimeRequest:#Exchange",
        ...data,
    };
    
    return result;
}
